/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export const tableOfContents = [];
export const title = "[FRESH] drowning in the mercury lounge";
export const date = "2022-03-02";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a",
    em: "em"
  }, props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["I released a collection of 6 mashups on\n", _jsx(_components.a, {
        href: "https://youtu.be/LVNvu8iD9hU",
        children: "YouTube"
      }), " and\n", _jsx(_components.a, {
        href: "https://soundcloud.com/21nvolved/sets/mix001",
        children: "SoundCloud"
      }), ".\nApart from the intro, all are trap vocals over indie rock or electronic\ninstrumentals. I've wanted to make more original music for a while now,\nso I hope having fewer unreleased mashups to work on will motivate me."]
    }), "\n", _jsxs(_components.p, {
      children: ["P.S. my piano pieces from 2018 are still on Bandcamp\n", _jsx(_components.a, {
        href: "https://dylanburati.bandcamp.com/album/at-rest-in-a-position-comfortable-for-breathing",
        children: "here"
      }), ".\nI'd recommend that album if you're a fan of ambient artists like Eluvium\nor of Angelo Badalamenti's ", _jsx(_components.em, {
        children: "Soundtrack from Twin Peaks"
      }), "."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
